// extracted by mini-css-extract-plugin
export default {"container":"styles_container__EB43K","titleBlock":"styles_titleBlock__QDt-p","title":"styles_title__TwYLv"};